import { ModalHeaderButton } from '@components/modal-header-button';
import { PropTypes } from 'prop-types';
import React from 'react';

import { Flex } from '../../../grid';
import { P, H4 } from '../../../typography/new';

const ModalHeader = ({ modalTitle, handleBack, handleClose, headingHeader }) => {
  const HeadingComponent = headingHeader ? H4 : P;

  return (
    <Flex alignItems="center" flexDirection="column" p="16px 16px 8px 16px">
      <ModalFloatingHeader isAbsolute={false} handleClose={handleClose} handleBack={handleBack} pt="0" />
      <HeadingComponent
        my="0"
        whiteSpace="break-spaces"
        pt={headingHeader ? '16px' : '0'}
        textAlign="center"
        variant="large-bold"
      >
        {modalTitle}
      </HeadingComponent>
    </Flex>
  );
};

ModalHeader.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleBack: PropTypes.func,
  modalTitle: PropTypes.string,
  headingHeader: PropTypes.bool,
};

ModalHeader.defaultProps = {
  handleBack: null,
  modalTitle: null,
  headingHeader: false,
};

const ModalFloatingHeader = ({ handleClose, handleBack, dark, children, isAbsolute, ...rest }) => (
  <>
    <Flex
      position={isAbsolute ? 'absolute' : 'sticky'}
      flexDirection="column"
      top="0"
      width="100%"
      paddingTop="16px"
      right="16px"
      zIndex={50}
      {...rest}
    >
      <Flex justifyContent={handleBack ? 'space-between' : 'flex-end'} width="100%">
        {handleBack && (
          <ModalHeaderButton
            dark={dark}
            onClick={handleBack}
            icon="chevronLeft"
            title="Back"
            align="left"
            ariaLabel="Back"
          />
        )}
        <ModalHeaderButton
          dark={dark}
          onClick={handleClose}
          title="Close"
          data-testid="modal-close-button"
          ariaLabel="Close"
        />
      </Flex>
      {children}
    </Flex>
  </>
);

ModalFloatingHeader.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleBack: PropTypes.func,
  dark: PropTypes.bool,
  children: PropTypes.node,
  isAbsolute: PropTypes.bool,
};

ModalFloatingHeader.defaultProps = {
  handleBack: undefined,
  dark: false,
  children: null,
  isAbsolute: true,
};

export { ModalHeader, ModalFloatingHeader };
